import React from "react";

import { css } from "@emotion/css";
import { desktop, laptop, tablet } from "../../../styles/breakpoints";

import BG from "../../../img/jpg/retailers/helps-bg.jpg";
import BGM from "../../../img/jpg/retailers/helps-bg-mobile.jpg";
import Flip11 from "../../../img/svg/retailers/flip-1-1.svg";
import Flip12 from "../../../img/png/retailers/flip-1-2.png";
import Flip21 from "../../../img/png/retailers/flip-2-1.png";
import Flip22 from "../../../img/png/retailers/flip-2-2.png";
import Flip31 from "../../../img/png/retailers/flip-3-1.png";
import Flip32 from "../../../img/png/retailers/flip-3-2.png";
import Flip41 from "../../../img/png/retailers/flip-4-1.png";
import Flip42 from "../../../img/png/retailers/flip-4-2.png";
import Flip51 from "../../../img/png/retailers/flip-5-1.png";
import Flip52 from "../../../img/png/retailers/flip-5-2.png";
import Flip61 from "../../../img/png/retailers/flip-6-1.png";
import Flip62 from "../../../img/png/retailers/flip-6-2.png";
import Flip71 from "../../../img/png/retailers/flip-7-1.png";
import Flip72 from "../../../img/png/retailers/flip-7-2.png";
import Flip81 from "../../../img/png/retailers/flip-8-1.png";
import Flip82 from "../../../img/png/retailers/flip-8-2.png";
import Flip91 from "../../../img/png/retailers/flip-9-1.png";
import Flip92 from "../../../img/png/retailers/flip-9-2.png";
import Pointer from "../../../img/png/retailers/pointer.png";
import Logo from "../../../img/png/retailers/helps-logo.png";
import { useI18n } from "../../../i18n";

const boxes = [
  {
    alt: "reduce return rates",
    img: Flip11,
    imgActive: Flip12,
  },
  {
    alt: "Increase conversion rates",
    img: Flip21,
    imgActive: Flip22,
  },
  {
    alt: "Enhance CUSTOMER experience",
    img: Flip31,
    imgActive: Flip32,
  },
  {
    alt: "optimize inventory management",
    img: Flip41,
    imgActive: Flip42,
  },
  {
    alt: "enhance marketing efforts",
    img: Flip51,
    imgActive: Flip52,
  },
  {
    alt: "Increase AOV",
    img: Flip61,
    imgActive: Flip62,
  },
  {
    alt: "improve customer retention rates",
    img: Flip71,
    imgActive: Flip72,
  },
  {
    alt: "customer insights & analytics",
    img: Flip81,
    imgActive: Flip82,
  },
  {
    alt: "increased sustainability",
    img: Flip91,
    imgActive: Flip92,
  },
];

const Helps = () => {
  const { t } = useI18n();

  return (
    <div className={style.main}>
      <div className={style.container}>
        <img alt={t("retailers_alt_zilouet")} src={Logo} />
        <h2>{t("retailers_helps")}</h2>
        <div className="wrapper">
          <img src={Pointer} alt={t("retailers_alt_click")} />
          {Object.values(boxes).map((v, i) => {
            return (
              <div className="flip-card">
                <span style={{display: 'none'}}>{t(`retailers_box_${i + 1}`)}</span>
                <span
                  className="front-card"
                  style={{ backgroundImage: `url(${v.img})` }}
                ></span>
                <span
                  className="back-card"
                  style={{ backgroundImage: `url(${v.imgActive})` }}
                ></span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const style = {
  main: css({
    paddingTop: 190,
    paddingBottom: 224,
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    backgroundSize: "cover",
    backgroundImage: `url(${BG})`,
    [desktop]: {
      paddingTop: 247,
      paddingBottom: 238,
    },
    [laptop]: {
      paddingTop: 200,
      paddingBottom: 200,
      paddingLeft: 30,
      paddingRight: 30,
      backgroundImage: `url(${BGM})`,
    },
    [tablet]: {
      paddingTop: 100,
      paddingBottom: 100,
    },
  }),
  container: css({
    maxWidth: 861,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",

    h2: {
      color: "#000",
      textAlign: "center",
      fontFamily: "Syne",
      fontSize: 160,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "162px",
      marginBottom: 100,
    },
    img: {
      width: 310,
      height: 89,
      marginBottom: 60,
    },
    ".wrapper": {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gridTemplateRows: "1fr 1fr",
      gap: 40,
      marginTop: 150,

      img: {
        display: 'none'
      }
    },
    ".gap":{
      height: 50
    },
    ".flip-card": {
      position: "relative",
      width: 330,
      height: 300,
      background: "transparent",
      transformStyle: "preserve-3d",
      perspective: 2000,

      '&:nth-child(1), &:nth-child(3), &:nth-child(5), &:nth-child(7), &:nth-child(9)': {
        marginTop: -150
      }
    },
    ".front-card": {
      position: "absolute",
      height: "100%",
      width: "100%",
      backfaceVisibility: "hidden",
      transition: "all 1s",
      backgroundSize: "contain",
      backgroundPositon: "center center",
      backgroundRepeat: "no-repeat",
      opacity: 1,
    },
    ".back-card": {
      position: "absolute",
      height: "100%",
      width: "100%",
      backgroundSize: "contain",
      backgroundPositon: "center center",
      backgroundRepeat: "no-repeat",
      backfaceVisibility: "hidden",
      opacity: 0,
      transition: "all 1s",
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
    },
    ".flip-card:hover": {
      ".front-card": {
        opacity: 0
      },

      ".back-card": {
        opacity: 1
      },
    },

    [desktop]: {
      h2: {
        fontSize: 156,
        lineHeight: "155px",
      },

      ".wrapper": {
        position: 'relative',
        img: {
          position: 'absolute',
          top: '-130px',
          right: '-90px',
          zIndex: 1,
          display: 'block',
          width: 140,
          height: 64,
        }
      }
    },
    [laptop]: {
      h2: {
        fontSize: 113,
        lineHeight: '112px',
        marginBottom: 85,
      },
      img: {
        width: 170,
        height: 'auto',
        marginBottom: 30,
      },
      ".wrapper": {
        gridTemplateColumns: "1fr",
        gridTemplateRows: "1fr",
        gap: 40,
        marginTop: 0,

        img: {
          top: '320px',
          right: 0,
          left: 100,
          margin: 'auto',
          width: 140,
          height: 64,
        }
      },
      ".flip-card": {
        width: 399,
        height: 361,

        '&:nth-child(1), &:nth-child(3), &:nth-child(5), &:nth-child(7), &:nth-child(9)': {
          marginTop: 0
        }
      },
    },
    [tablet]: {
      h2: {
        fontSize: 58,
        lineHeight: '68px',
        marginBottom: 100,
        maxWidth: 288
      },
      img: {
        width: 138,
        marginBottom: 43,
      },
      ".wrapper": {
        gap: 60,

        img: {
          top: '210px',
          right: 0,
          left: 0,
          width: 120,
          height: 57,
        }
      },
      ".flip-card": {
        width: 257,
        height: 233,
      },
    },
  }),
};

export default Helps;
